import styles from './styles/StatusBar.module.scss';
import React from 'react';
import { SelectedFilters } from './SelectedFilters';
import { NbOfItems } from './NbOfItems';
export const StatusBar = () => {
    return (React.createElement("div", { className: `d:flex:xl-up ai:center ${styles.container}` },
        React.createElement(SelectedFilters, null),
        React.createElement(NbOfItems, null)));
};
